import {
  BOUNDS_U,
  BOUNDS_V,
  crossesXBoundary,
  crossesYBoundary,
} from 'features/geometry/boundaryUtils'
import { LineDirectionX, LineDirectionY } from 'types'

/**
 * If the polygon defined by uvs wraps, then create a polygon for the left (or bottom in y direction)
 * side and right (or top in y direction).
 * @param uvs
 * @param lineXDirections
 * @param lineYDirections
 * @param wrapsX
 * @param wrapsY
 * @returns
 */
export const createPolygonsForWrapping = (
  uvs: number[],
  lineXDirections: ReadonlyArray<LineDirectionX>,
  lineYDirections: ReadonlyArray<LineDirectionY>,
  wrapsX: boolean,
  wrapsY: boolean
): number[][] => {
  if (!wrapsX && !wrapsY) return [uvs]

  let polygonDoesntWrap = true
  let startsOnBottomOrLeft = true
  for (let i = 0; i < uvs.length - 2; i = i + 2) {
    const sx = uvs[i]
    const sy = uvs[i + 1]
    const ex = uvs[i + 2]
    const ey = uvs[i + 3]
    const xDirection = lineXDirections[Math.floor(i / 2)]
    const yDirection = lineYDirections[Math.floor(i / 2)]
    const lineIntersects = wrapsX
      ? crossesXBoundary(sx, ex, xDirection)
      : crossesYBoundary(sy, ey, yDirection)
    if (lineIntersects) {
      polygonDoesntWrap = false
      startsOnBottomOrLeft = wrapsX
        ? xDirection === LineDirectionX.Right
        : yDirection === LineDirectionY.Up
      break
    }
  }
  if (polygonDoesntWrap) return [uvs]

  const polygon: number[] = []
  const partnerPolygon: number[] = []

  let currentlyOnBottomOrLeft = startsOnBottomOrLeft

  for (let i = 0; i < uvs.length; i = i + 2) {
    const u = uvs[i]
    const v = uvs[i + 1]
    const xDirection = lineXDirections[Math.floor(i / 2)]
    const yDirection = lineYDirections[Math.floor(i / 2)]

    const partnerU = wrapsX
      ? currentlyOnBottomOrLeft
        ? u - BOUNDS_U[1]
        : u + BOUNDS_U[1]
      : u
    const partnerV = wrapsY
      ? currentlyOnBottomOrLeft
        ? v - BOUNDS_V[1]
        : v + BOUNDS_V[1]
      : v
    if (currentlyOnBottomOrLeft === startsOnBottomOrLeft) {
      polygon.push(u, v)
      partnerPolygon.push(partnerU, partnerV)
    } else {
      polygon.push(partnerU, partnerV)
      partnerPolygon.push(u, v)
    }
    const lineIntersects = wrapsX
      ? crossesXBoundary(u, uvs.at(i + 2), xDirection)
      : crossesYBoundary(v, uvs.at(i + 3), yDirection)
    if (lineIntersects) currentlyOnBottomOrLeft = !currentlyOnBottomOrLeft
  }
  return [polygon, partnerPolygon]
}
